export default __webpack_public_path__ + "static/media/DSCN8366.ad0890ac.JPG";